export default "__VITE_ASSET__A5dntsc6__"